export const SET_DEALS = 'SET_DEALS'
export const REMOVE_DEAL = 'REMOVE_DEAL'
export const SET_CONTACTS = 'SET_CONTACTS'
export const SET_TEMPLATES = 'SET_TEMPLATES'
export const SELECT_GLOBAL_TEMPLATE = 'SELECT_GLOBAL_TEMPLATE'
export const REMOVE_CONTACT = 'REMOVE_CONTACT'
export const TOGGLE_CONTACT_DEAL = 'TOGGLE_CONTACT_DEAL'
export const SET_CONTACT_FOLLOWUP_DATE = 'SET_CONTACT_FOLLOWUP_DATE'
export const SET_CONTACT_EMAIL_SUBJECT = 'SET_CONTACT_EMAIL_SUBJECT'
export const SET_CONTACT_EMAIL_FILES = 'SET_CONTACT_EMAIL_FILES'
export const REMOVE_FILE = 'REMOVE_FILE'
export const SET_CONTACT_EMAIL_TEMPLATE = 'SET_CONTACT_EMAIL_TEMPLATE'
export const SET_CONTACT_EMAIL_TEMPLATE_BODY = 'SET_CONTACT_EMAIL_TEMPLATE_BODY'
export const SET_CONTACT_EMAIL_SENT = 'SET_CONTACT_EMAIL_SENT'
export const SET_FOLLOW_UP_DATE = 'SET_FOLLOW_UP_DATE'
export const SET_CC_CONTACTS = 'SET_CC_CONTACTS'
